import { useCallback, useRef } from 'react';

/**
 * Returns a stable function reference that always calls the latest
 * version of the provided callback.
 *
 * Equivalent to the proposed React `useEffectEvent` hook. Once React
 * ships `useEffectEvent` as stable, this can be replaced with a
 * one-line re-export.
 *
 * Use this when a callback needs to be passed through context or as
 * an effect dependency without causing consumer re-renders or effect
 * re-fires when its closure values change.
 */
export const useEffectEvent = <T extends (...args: any[]) => any>(callback: T): T => {
  const ref = useRef(callback);
  ref.current = callback;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((((...args: any[]) => ref.current(...args)) as unknown) as T, []);
};
